import { useMedia } from 'use-media'
import { SCREEN } from 'f-web/src/styles'

export default function useMediaMinXS() {
  return useMedia({ minWidth: SCREEN.XS })
}
